import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { createGame, backupGame, deleteGame, updatePlayers, createChoices } from '../../store/actions/gameActions'
import { Redirect, useHistory } from 'react-router-dom'
import Checkbox from '../layout/CheckboxBlack'

function createNewGame(settings, currentGames, dispatch){
  if(currentGames && currentGames!==null){
    let sameName = Object.entries(currentGames).some((game)=>{
      return(game[1]['settings']['gameName'].toString() === settings['gameName'].toString());
    });
    if(!sameName){
      dispatch(createGame(settings));
    }
    else{
      window.alert('there is already a game with that name');
    }  
  }
  else{
    dispatch(createGame(settings));
  }
  
}

function createPlayerChoices(gameId, settings, dispatch){
  //const playerChoices =  Array(parseInt(settings["numOfPlayers"])).fill(Array(parseInt(settings["numOfChoices"])).fill(false));
  const playerChoices = {};
  for(var player in settings["currentPlayers"]){
    //console.log(settings["currentPlayers"][player]);
    //console.log("ALSBJKFDOSKSG");
    playerChoices[settings["currentPlayers"][player]] = Array(parseInt(settings["numOfChoices"])).fill(false);
  }
  //console.log('player choices');
  //console.log(playerChoices);
  dispatch(createChoices(gameId, playerChoices));
}

function handlePlayers(value, setNumOfPlayers, setCurrentPlayers){
  if(parseInt(value) < 7 && parseInt(value) > 1){
    setNumOfPlayers(parseInt(value));
    setCurrentPlayers(Array(parseInt(value)).fill(false));  
  }
  else{
    setNumOfPlayers("");
  }
}

function handleJoin(userId, index, currentPlayers, currentNames, dispatch, gameId, settings, playerName){
  var newPlayers = [...currentPlayers];
  newPlayers[index]=userId;

  var newNames = {...currentNames};
  newNames[userId] = playerName;

  var newSettings = settings;
  newSettings['currentPlayers'] = newPlayers;
  newSettings['currentNames'] = newNames; 


  dispatch(updatePlayers(gameId, newSettings));
}

function closeFunction(){
    document.getElementById("myModal").style.display = "none";
    document.getElementById("joinModal").style.display = "none";
  }

function handleJoinInput(){
    document.getElementById("joinModal").style.display = "block"; 
  }

function handleJoinButton(name, currentGames, setJoinRedirect){
  if(currentGames){
    for(var object in currentGames){
      if(currentGames[object]['settings']['gameName'] === name){
        setJoinRedirect(object);
      }
    }
  }
}

function handleChoices(event, setNumOfChoices){
  event.preventDefault();
  if(parseInt(event.target.value) < 7 && parseInt(event.target.value) > 0){
    setNumOfChoices(parseInt(event.target.value));  
  }
  else{
    setNumOfChoices("");
  }
}

function handleDistance(event, setMaxDistance){
  event.preventDefault();
  if(parseInt(event.target.value) < 100 && parseInt(event.target.value) > 0){
    setMaxDistance(parseInt(event.target.value));  
  }
  else{
    setMaxDistance("");
  }
}

function handleDelete(){
  document.getElementById("myModal").style.display = "block";  
}

function handleDeleteGame(props, game, dispatch, history, clearChoices){
  dispatch(backupGame(game));
  dispatch(deleteGame(props.match.params.gameId, ()=>{
    clearChoices();
    history.push("/game/createGame");
    M.updateTextFields();
  }));
}

function Game(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const currentGames = useSelector((state)=>state.firestore.data.games);
  const [currentGame, setCurrentGame] = useState(false);
  const userId = useSelector((state)=>state.firebase.auth.uid);
  const user = useSelector((state)=>state.firestore.data.users[userId]);
  const [numOfPlayers, setNumOfPlayers] = useState(2);
  const [numOfChoices, setNumOfChoices] = useState(3);
  const [gameName, setGameName] = useState(false);
  const [playerName, setPlayerName] = useState(false);
  const [currentPlayers, setCurrentPlayers] = useState(Array(numOfPlayers).fill(false));
  const [currentNames, setCurrentNames] = useState({test:'test'});
  const [randomChoice, setRandomChoice] = useState(false);
  const [fromFavorites, setFromFavorites] = useState(false);
  const [maxDistance, setMaxDistance] = useState(99);
  const settings = {
    numOfPlayers: numOfPlayers,
    numOfChoices: numOfChoices,
    gameName: gameName,
    currentPlayers: currentPlayers,
    currentNames: currentNames,
    randomChoice: randomChoice,
    fromFavorites: fromFavorites,
    maxDistance: maxDistance
  }
  const [joinGameName, setJoinGameName] = useState(false);
  const [joinRedirect, setJoinRedirect] = useState(false);
  const [userDelete, setUserDelete] = useState(false);

  useEffect(()=>{M.updateTextFields()}
  ,[])

  function clearChoices(){
    setNumOfPlayers(2);
    setNumOfChoices(3);
    setCurrentGame(false);
    setGameName(false);
    setPlayerName(false);
    setCurrentPlayers(Array(2).fill(false));
    setCurrentNames({test:'test'});
    setRandomChoice(false);
    setFromFavorites(false);
    setMaxDistance(99);
  }

  if (!userId) return <Redirect to='/signin' />

  if(currentGames === null && window.location.pathname !== '/game/createGame'){
    return <Redirect to={'/'} />   
  }

  if(user && playerName===false){
    //console.log('user');
    //console.log(user.firstName);
    setPlayerName(user.firstName + " " + user.lastName);
  }

// detect if the player list is full, redirect if true 
  var gameInProgress = !currentPlayers.some(obj => !obj);
  if(gameInProgress){
    //console.log("CURRENT GAMEMMEMEME");
    //console.log(currentGame);
    if(currentGame["authorId"] === userId && !currentGame["playerChoices"]){
      createPlayerChoices(props.match.params.gameId, settings, dispatch);
    }
    return <Redirect to={'/gameInProgress/' + props.match.params.gameId} />  
  }

  if(window.location.pathname !== '/game/createGame'){
    if(currentGames && currentGames[props.match.params.gameId] && currentGame !== currentGames[props.match.params.gameId]){
      setCurrentGame(currentGames[props.match.params.gameId]);
    }
    else if (currentGames && !currentGames[props.match.params.gameId]){
      return <Redirect to={'/game/createGame'} />  
    }
  }
  else if(currentGames){
    for(var object in currentGames){
      if(currentGames[object] && currentGames[object]['authorId'] === userId){
        return <Redirect to={'/game/' + object} />
      }
      else if(currentGames[object] && currentGames[object]['settings'] && currentGames[object]['settings']['currentPlayers'].includes(userId)){
        return <Redirect to={'/game/' + object} /> 
      }
    }
  }

  if(joinRedirect && window.location.pathname !== '/game/' + joinRedirect){
    return <Redirect to={'/game/' + joinRedirect} />
  }

// load game settings if there is a game
  if(currentGames && userId && currentGame){
    if(numOfPlayers!==currentGame.settings.numOfPlayers){
      setNumOfPlayers(currentGame.settings.numOfPlayers);  
    }
    if(numOfChoices!==currentGame.settings.numOfChoices){
      setNumOfChoices(currentGame.settings.numOfChoices);
    }
    if(gameName!==currentGame.settings.gameName){
      setGameName(currentGame.settings.gameName);
    }
    if(currentPlayers!==currentGame.settings.currentPlayers){
      setCurrentPlayers(currentGame.settings.currentPlayers);
    }
    if(currentNames!==currentGame.settings.currentNames){
      setCurrentNames(currentGame.settings.currentNames);
    }
    if(randomChoice!==currentGame.settings.randomChoice){
      setRandomChoice(currentGame.settings.randomChoice)
    }    
    if(fromFavorites!==currentGame.settings.fromFavorites){
      setFromFavorites(currentGame.settings.fromFavorites)
    }
    if(maxDistance!==currentGame.settings.maxDistance){
      setMaxDistance(currentGame.settings.maxDistance)
    }
  }
  
  return (
    <>
      <div style={{display:"flex", flexFlow:"column"}}>
        <div id="myModal" className="modal2">
                <div className="modal-content2">
                  <span className="close2" onClick={()=>{closeFunction()}}>&times;</span>
                  <p>Are you sure you want to delete?</p>
                  { 
                  <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                    <button className="btn pink lighten-1" onClick={()=>{handleDeleteGame(props, currentGame, dispatch, history, clearChoices)}}>Delete</button>
                  </div>
                  }
              </div>
        </div>
        { window.location.pathname === '/game/createGame' &&  
        <div>
          <div id="joinModal" className="modal2">

              <div className="modal-content2">
                <span className="close2" onClick={()=>{closeFunction()}}>&times;</span>
                <p>Enter the name of the tournament you want to join.</p>  
                <div className="input-field">
                  <input type="text" id='name' name='name' onChange={event => setJoinGameName(event.target.value)} />
                  <label htmlFor="title">Tournament Name</label>
                </div>
                <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                  <button className="btn pink lighten-1" onClick={()=>{handleJoinButton(joinGameName, currentGames, setJoinRedirect)}}>Join</button>
                </div>
            </div>
    
          </div>
          <div style={{"display": "flex", "justifyContent": "center"}}>
            <form className="formContainer" autoComplete="off" onSubmit={e => e.preventDefault()}>
                <h5 className="grey-text text-darken-3" style={{"display":"flex", "justifyContent":"center"}}>Create a Game</h5>
                <div className="input-field">
                  <input type="text" id='name' name='name' value={playerName} onChange={event => setPlayerName(event.target.value)} />
                  <label htmlFor="title">Your Name</label>
                </div>
                <div className="input-field">
                  <input type="text" id='name' name='name' onChange={event => setGameName(event.target.value)} />
                  <label htmlFor="title">Tournament Name</label>
                </div>
                <div className="input-field">
                  <label htmlFor="quantity">Number of Players (between 2 and 6):</label>
                  <input className="active" type="number" id="quantity1" name="quantity" min="2" max="6" value={numOfPlayers} onChange={event => handlePlayers(event.target.value, setNumOfPlayers, setCurrentPlayers)}/>
                </div>
                <div className="input-field">
                  <label htmlFor="quantity">Number of Choices (between 1 and 6):</label>
                  <input className="active" type="number" id="quantity2" name="quantity" min="1" max="6" value={numOfChoices} onChange={event => handleChoices(event, setNumOfChoices)}/>
                </div>
                {/*<Checkbox label = 'Random Choices' id='randomChoice' isSelected={randomChoice} onCheckboxChange = {()=>{setRandomChoice(!randomChoice)}} />
                <div className="input-field">
                  <label htmlFor="quantity">Max Distance for Random Choices (miles):</label>
                  <input className="active" type="number" id="quantity3" name="quantity" min="1" max="99" value={maxDistance} onChange={event => handleDistance(event, setMaxDistance)}/>
                </div>*/}
                {/*<Checkbox label = 'Choose From Favorites' id='fromFavorites' isSelected={fromFavorites} onCheckboxChange = {()=>{setFromFavorites(!fromFavorites)}} />*/}
            </form>
          </div>
          <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
            <button className="btn pink lighten-1" onClick={()=>{createNewGame(settings, currentGames, dispatch)}}>Create New Game</button>
          </div>
          <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
            <button className="btn pink lighten-1" onClick={()=>{handleJoinInput()}}>Join a Game</button>
          </div>
        </div>
        }
        { currentGames && currentGame && window.location.pathname !== '/game/createGame' &&  
        <div>
          <div style={{"display": "flex", "justifyContent": "center"}}>
            
          </div>
          <div>
            <p style={{textAlign:"center"}}>{gameName}</p>
            <div>
              {
                currentPlayers && currentPlayers.map((player, index)=>{
                  if(player === false && !currentPlayers.includes(userId)){
                    return(
                      <div key={"joinButton"+index} className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                        <button className="btn pink lighten-1" onClick={()=>{handleJoin(userId, index, currentPlayers, currentNames, dispatch, props.match.params.gameId, settings, playerName)}}>{"Join as Player "+ (parseInt(index)+1) }</button>
                      </div>
                    )  
                  }
                  else if(player === false && currentPlayers.includes(userId) && currentPlayers[index] !== userId){
                    return(
                      <div key={"player"+index} style={{"display": "flex", "justifyContent": "center"}}>
                        <p>{'waiting on player ' + (index+1)}</p>
                      </div>
                    )  
                  }
                  else{
                    return(
                      <div key={"player"+index} style={{"display": "flex", "justifyContent": "center"}}>
                        <p>{currentNames[player]}</p>
                      </div>
                    )
                  }

                })
              }
            </div>
          </div>
          { (currentGame['authorId'] === userId || userDelete) &&
            <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
              <button className="btn pink lighten-1" onClick={()=>{handleDelete()}}>Delete Game</button>
            </div>
          }

        </div>
        }
        
      </div>
    </>
  );
}

export default Game;